import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { TextLoca } from "../generic/text/TextLoca";
export var DialogContent = function (_a) {
    var messageLocaId = _a.messageLocaId;
    return (React.createElement("div", { className: "flex flex--guts flex--stacked flex__full" },
        React.createElement("hr", { className: "dialog-divider" }),
        React.createElement("span", { className: "flex flex--guts " + IdStyles.TextAlignCenter + " " + IdStyles.TextNormal },
            React.createElement(TextLoca, { id: messageLocaId })),
        React.createElement("hr", { className: "dialog-divider" })));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/errors/DialogContent.tsx
// module id = 186
// module chunks = 3